<template>
  <div>
    <WuMaoList v-if="isWuMaoAccount" />
    <ChengKuangPurchaseOverview v-else />
  </div>
</template>
<script>
  import ChengKuangPurchaseOverview from './chengkuang/purchaseOverview.vue';
  import WuMaoList from './wumao/index.vue';
  export default {
    name: 'purchaseOverview',
    components: {
      ChengKuangPurchaseOverview,
      WuMaoList,
    },
  };
</script>

<style lang="scss" scoped></style>
